import API_URLS from "../config/api";

export const fetchCastleData = async (castleId) => {
  try {
    if (!castleId || typeof castleId !== "number") {
      console.error("❌ Invalid Castle ID provided:", castleId);
      return null; // Return null instead of an empty object
    }

    const apiEndpoint = API_URLS.GET_CASTLE(castleId); // Fetch ALL data
   

    const response = await fetch(apiEndpoint);

    if (!response.ok) {
      console.error(
        `❌ API Request Failed: ${response.status} ${response.statusText}`
      );
      return null;
    }

    const data = await response.json();
   

    if (data.success) {
      // console.log("\n🔽 Castle Data Breakdown:");
      // console.log("🏰 Castle Name:", data.data.castle_name || "Unknown Castle");
      // console.log(
      //   "📜 Intro Text (Part 1):",
      //   data.data.intro_text?.part_1 || "No intro available."
      // );
      // console.log("🎵 Audio Files:", data.data.audio || "No audio found");
      // console.log("❓ Questions:", data.data.questions || "No questions found");
      // console.log("📅 Year:", data.data.year || "Unknown");
      // console.log("📍 Location:", data.data.location || "Unknown");
      // console.log("📖 Events:", data.data.events || "No events available");

      // console.log("--------------------------------------------------\n");

      return data.data; // Return the FULL castle object
    } else {
      console.error(
        "❌ Error Fetching Castle Data:",
        data.message || "Unknown API error"
      );
      return null;
    }
  } catch (error) {
    console.error("\n🚨 Fetch Error:", error);
    return null;
  }
};

// 📜 Fetch Castle Description
export const fetchCastleDescription = async (castleId) => {
  const castleData = await fetchSingleCastle(castleId);
  return castleData ? castleData.description : null;
};

// 🖼 Fetch Castle Images
export const fetchCastleImages = async (castleId) => {
  const castleData = await fetchSingleCastle(castleId);
  return castleData ? castleData.images : null;
};

// 🎵 Fetch Castle Audio
export const fetchCastleAudio = async (castleId) => {
  const castleData = await fetchSingleCastle(castleId);
  return castleData ? castleData.audio : null;
};

// 📜 Fetch Castle Intro Text
export const fetchCastleIntroText = async (castleId) => {
  const castleData = await fetchSingleCastle(castleId);
  return castleData ? castleData.intro_text : null;
};

// 🏰 Fetch a Single Castle by ID
export const fetchSingleCastle = async (castleId) => {
  

  try {
    const response = await fetch(API_URLS.GET_CASTLE(castleId));
    const data = await response.json();

    if (!response.ok || !data.success) {
      console.error(`❌ Failed: ${response.status} ${response.statusText}`);
      return null;
    }

    // console.log(`✅ Success: Castle ID ${castleId} Data Fetched!`);
    return data.data;
  } catch (error) {
    // console.error(`🚨 Error Fetching Castle ID ${castleId}:`, error);
    return null;
  }
};

// ❓ Fetch Questions for a Castle
export const fetchCastleQuestions = async (castleId, difficulty, set) => {
  // console.log(
  //   `\n🔹 Fetching Questions for Castle ID: ${castleId}, Difficulty: ${difficulty}, Set: ${set}...`
  // );

  try {
    const response = await fetch(
      API_URLS.GET_CASTLE_QUESTIONS(castleId, difficulty, set)
    );
    const data = await response.json();

    if (!response.ok || !data.success) {
      console.error(`❌ Failed: ${response.status} ${response.statusText}`);
      return null;
    }

    console.log(
      `✅ Success: Questions for Castle ID ${castleId} (Difficulty: ${difficulty}, Set: ${set}) Fetched!`
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error(
      `🚨 Error Fetching Questions for Castle ID ${castleId}:`,
      error
    );
    return null;
  }
};

// 🔥 Fetch ALL Data and Show API Routes
const testAPIs = async () => {
  console.log("\n🚀 Starting API Tests...\n");

  const allCastles = await fetchAllCastles();
  if (!allCastles || allCastles.length === 0) {
    console.error("❌ No castles available for testing.");
    return;
  }

  const randomCastle =
    allCastles[Math.floor(Math.random() * allCastles.length)];
  console.log(
    `🔹 Randomly Selected Castle: ${randomCastle.castle_name} (ID: ${randomCastle.castle_id})`
  );

  const castleId = randomCastle.castle_id;

  // Fetch all details separately
  const [
    castleData,
    description,
    images,
    audio,
    introText,
    easySet1,
    easySet2,
    hardSet1,
    hardSet2,
  ] = await Promise.all([
    fetchSingleCastle(castleId),
    fetchCastleDescription(castleId),
    fetchCastleImages(castleId),
    fetchCastleAudio(castleId),
    fetchCastleIntroText(castleId),
    fetchCastleQuestions(castleId, "easy", "set_1"),
    fetchCastleQuestions(castleId, "easy", "set_2"),
    fetchCastleQuestions(castleId, "hard", "set_1"),
    fetchCastleQuestions(castleId, "hard", "set_2"),
  ]);

  const apiRoutes = {
    fetchAllCastles: API_URLS.GET_ALL_CASTLES,
    fetchSingleCastle: API_URLS.GET_CASTLE(castleId),
    fetchCastleDescription: API_URLS.GET_CASTLE(castleId),
    fetchCastleImages: API_URLS.GET_CASTLE(castleId),
    fetchCastleAudio: API_URLS.GET_CASTLE(castleId),
    fetchCastleIntroText: API_URLS.GET_CASTLE(castleId),
    fetchEasySet1: API_URLS.GET_CASTLE_QUESTIONS(castleId, "easy", "set_1"),
    fetchEasySet2: API_URLS.GET_CASTLE_QUESTIONS(castleId, "easy", "set_2"),
    fetchHardSet1: API_URLS.GET_CASTLE_QUESTIONS(castleId, "hard", "set_1"),
    fetchHardSet2: API_URLS.GET_CASTLE_QUESTIONS(castleId, "hard", "set_2"),
  };

  const resultData = {
    routes: apiRoutes,
    castleDetails: {
      castle_id: castleData?.castle_id,
      castle_name: castleData?.castle_name,
      intro_text: introText,
      description: description,
      images: images,
      audio: audio,
      year: castleData?.year || "Unknown", // ✅ Added year
      location: castleData?.location || "Unknown", // ✅ Added location
      events: castleData?.events || "No events available", // ✅ Added events
    },
    questions: {
      easy: { set_1: easySet1, set_2: easySet2 },
      hard: { set_1: hardSet1, set_2: hardSet2 },
    },
  };

  console.log("\n✅ API Tests Completed. Opening Results in New Tab...\n");
   openResultInNewTab(resultData);
};

// 🔍 Fetch ALL Castles
const fetchAllCastles = async () => {
  console.log("\n🔹 Fetching All Castles...");

  try {
    const response = await fetch(API_URLS.GET_ALL_CASTLES);
    const data = await response.json();

    if (!response.ok || !data.success) {
      console.error(`❌ Failed: ${response.status} ${response.statusText}`);
      return [];
    }

    console.log("✅ Success: All Castles Data Fetched!");
    return data.data;
  } catch (error) {
    console.error("🚨 Error Fetching All Castles:", error);
    return [];
  }
};

// ✅ Add a Button in the UI
const addTestButton = () => {
  const button = document.createElement("button");
  button.innerText = "Run API Tests";
  button.style.cssText =
    "position:fixed; bottom:20px; right:20px; padding:10px; font-size:16px; cursor:pointer;";
    button.style.display = "none";
  button.onclick = testAPIs;
  document.body.appendChild(button);
};

// // 🚀 Run on Page Load
window.onload = addTestButton;

// 🖥 Open Result in New Tab
const openResultInNewTab = (jsonData) => {
  const newTab = window.open();
  if (!newTab) {
    alert("❌ Popup Blocked! Please enable popups and try again.");
    return;
  }

  const formattedRoutes = JSON.stringify(jsonData.routes, null, 2)
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  const formattedDetails = JSON.stringify(jsonData.castleDetails, null, 2)
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  const formattedQuestions = JSON.stringify(jsonData.questions, null, 2)
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  newTab.document.write(`
    <html>
    <head>
      <title>🏰 Castle API Guide</title>
      <style>
        body { font-family: Arial, sans-serif; padding: 20px; line-height: 1.6; }
        h1, h2 { color: #2c3e50; }
        pre { background: #ecf0f1; padding: 15px; border-radius: 5px; white-space: pre-wrap; word-wrap: break-word; font-size: 14px; }
        code { background: #f4f4f4; padding: 3px 5px; border-radius: 4px; font-size: 13px; }
      </style>
    </head>
    <body>
      <h1>🏰 Castle API Guide</h1>
      <p>Welcome to the Castle API guide. Here’s how you can fetch every single piece of data for a castle using our API.</p>

      <h2>🔗 API Routes</h2>
      <pre>${formattedRoutes}</pre>

      <h2>📜 Fetching Castle Data</h2>
      <p>To fetch **all castle data** (including name, description, audio, images, etc.), make a GET request to:</p>
      <pre>fetch("${jsonData.routes.fetchSingleCastle}")
  .then(response => response.json())
  .then(data => console.log(data));</pre>

      <h2>📜 Fetching Castle Description</h2>
      <p>To get only the castle description:</p>
      <pre>fetch("${jsonData.routes.fetchCastleDescription}")
  .then(response => response.json())
  .then(data => console.log(data.description));</pre>

      <h2>🖼 Fetching Castle Images</h2>
      <p>To retrieve images for a castle:</p>
      <pre>fetch("${jsonData.routes.fetchCastleImages}")
  .then(response => response.json())
  .then(data => console.log(data.images));</pre>

      <h2>🎵 Fetching Castle Audio</h2>
      <p>To retrieve audio files:</p>
      <pre>fetch("${jsonData.routes.fetchCastleAudio}")
  .then(response => response.json())
  .then(data => console.log(data.audio));</pre>

      <h2>📜 Fetching Castle Intro Text</h2>
      <p>To fetch the introduction text of the castle:</p>
      <pre>fetch("${jsonData.routes.fetchCastleIntroText}")
  .then(response => response.json())
  .then(data => console.log(data.intro_text));</pre>

      <h2>❓ Fetching Questions</h2>
      <p>Questions are divided into **Easy & Hard** and into **Set 1 & Set 2**. Below are the queries:</p>

      <h3>🟢 Easy Questions - Set 1</h3>
      <pre>fetch("${jsonData.routes.fetchEasySet1}")
  .then(response => response.json())
  .then(data => console.log(data));</pre>

      <h3>🟢 Easy Questions - Set 2</h3>
      <pre>fetch("${jsonData.routes.fetchEasySet2}")
  .then(response => response.json())
  .then(data => console.log(data));</pre>

      <h3>🔴 Hard Questions - Set 1</h3>
      <pre>fetch("${jsonData.routes.fetchHardSet1}")
  .then(response => response.json())
  .then(data => console.log(data));</pre>

      <h3>🔴 Hard Questions - Set 2</h3>
      <pre>fetch("${jsonData.routes.fetchHardSet2}")
  .then(response => response.json())
  .then(data => console.log(data));</pre>

      <h2>📌 JavaScript Function Examples</h2>
      <p>Here’s how you can fetch and use this API in JavaScript:</p>

      <h3>✅ Example: Fetching Castle Description</h3>
      <pre>
async function getCastleDescription(castleId) {
    const response = await fetch(\`https://kastra.postscriptum.gr/api/castles/\${castleId}\`);
    const data = await response.json();
    console.log(data.description);
}

getCastleDescription(1);</pre>

      <h3>✅ Example: Fetching Questions Dynamically</h3>
      <pre>
async function getCastleQuestions(castleId, difficulty, set) {
    const response = await fetch(\`https://kastra.postscriptum.gr/api/castles/\${castleId}/questions?difficulty=\${difficulty}&set=\${set}\`);
    const data = await response.json();
    console.log(data);
}

getCastleQuestions(1, "easy", "set_1");</pre>

      <h2>🏰 Full Castle Details</h2>
      <pre>${formattedDetails}</pre>

      <h2>❓ Full Question Sets</h2>
      <pre>${formattedQuestions}</pre>

      <p><strong>💡 Tip:</strong> Use the above functions in your JavaScript project to dynamically fetch and display castle information.</p>
      
    </body>
    </html>
  `);

  newTab.document.close();
};
